// Route guard for admin-only pages.
//
// Hiding the sidebar link is not enough — the URL can still be typed in. This
// sends staff back to the dashboard instead of letting them load a page whose
// every request the API will reject.
//
// Cosmetic only: the API enforces the same rule on its own (see
// requireAdminRole), so a staff user who bypasses this gains nothing.

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function AdminOnly({ children }: { children: ReactNode }) {
  const auth = useAuth();

  // Still resolving the stored token — render nothing rather than briefly
  // bouncing an admin off their own page.
  if (auth.status === "loading") return null;
  if (auth.status !== "authenticated" || auth.user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
